import {useMemo, useRef} from 'react'
import {useMappedState} from 'redux-react-hook'
import useLeverageData from 'hooks/useLeverageData'
import {calculateViewData} from '../utils/futures'

function usePositionData () {
  const timeRef = useRef(0)
  const dataRef = useRef({})
  const mapState = state => ({
    balances: state?.entities?.balances || {},
    positions: state?.entities?.positions,
    symbolInfo: state?.entities?.symbolInfo
  })
  const {positions, balances, symbolInfo} = useMappedState(mapState)
  const {leverageData} = useLeverageData()
  const {curLeverage} = leverageData
  const data = useMemo(
    () => calculateViewData(positions,
      balances[(symbolInfo?.quoteAsset)]?.walletBalance, curLeverage),
    [positions, balances, symbolInfo, curLeverage]
  )
  const now = Date.now()
  if (timeRef.current && now - timeRef.current < 250) {
    return dataRef.current
  }
  timeRef.current = now
  dataRef.current = data
  return data
}

export default usePositionData
